import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

@Component({
  selector: 'mobile-drop-down',
  templateUrl: './mobile-drop-down.component.html',
  styleUrls: ['./mobile-drop-down.component.scss']
})
export class MobileDropDownComponent implements OnInit, OnDestroy {
  @Input() filterInfo = null;
  @Output() dataSelected: EventEmitter<any> = new EventEmitter();
  @Input() optionSelected = "";
  
  constructor() {
    
   }
 

  valueChanged(event) {
    this.dataSelected.emit(this.filterInfo);
  }

  ngOnInit() {
    //this.filterInfo['value'] = "FG";
    //this.filterInfo['value'] = 'NA';
    // this.message.getMessage().subscribe(message => {
    //   if (message && message.filterReset) {
    //     this.selected = this.defaultValueField;
    //   }
    // });
        
  }

  ngOnDestroy(){
    this.filterInfo = null;
    this.optionSelected = null;
    
  }
  

}
